"use client";

import styled from "styled-components";

export const Modal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const Dialog = styled.div``;

export const ModalContent = styled.div`
  position: relative;
  background-color: var(--backgroundColor);
  color: var(--colorTitle);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 500px;
  max-width: 90%;
  margin: auto;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  padding: 20px 0;
`;

export const ModalTitle = styled.h1`
  text-align: center;
  font-family: "Inter SemiBold";
  font-size: 23px;
  display: block;
  width: 100%;
`;

export const ModalBtnClose = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  transition: 0.3s;
  &:focus {
    box-shadow: none !important;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
`;
